import {useState, useEffect} from 'react';
import {tasveerStorage, tasveerStore, timestamp} from '../firebase/config';


const useThumbStorage = (file, genre, imgUrl) => {
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState(null);
    const [url, setUrl] = useState(null);
    

    useEffect(() => {
        const storageRef = tasveerStorage.ref().child('thumbnails/'+file.name);
        const storeRef = tasveerStore.collection("thumbnails");
        storageRef.put(file).on('state_changed', (snap) => {
            let percent = (snap.bytesTransferred / snap.totalBytes) * 100;
            setProgress(percent);
        }, (err) => {
            setError(err);
        }, async () => {
            const thumburl = await storageRef.getDownloadURL();
            const createdAt = timestamp();
            console.log("Added");
            storeRef.add({name:file.name , url: thumburl, imageUrl: imgUrl , genre, createdAt});
            setUrl(thumburl);
        });
    }, [file, genre, imgUrl]);

    return { url,progress, error };

}


export default useThumbStorage;